import { createTheme } from '@mui/material/styles';

// Careva brand color: #619648 (green)
// Light theme with green primary color
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#619648', // Careva brand green
      light: '#8BC574',
      dark: '#4A7A38',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#DC6B4E', // Warm coral (complementary to green)
      light: '#F08A6E',
      dark: '#B84A2E',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FEFBFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1C1E',
      secondary: '#44474F',
    },
  },
});

// Dark theme with green primary color
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9FD67F', // Light green for dark mode
      light: '#B4E89A',
      dark: '#7AB85F',
      contrastText: '#1A3D1A',
    },
    secondary: {
      main: '#F08A6E', // Light coral for dark mode
      light: '#FFA88C',
      dark: '#DC6B4E',
      contrastText: '#3D1A0F',
    },
    background: {
      default: '#0F1419',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#E1E2EC',
      secondary: '#C5C6D0',
    },
  },
});

// Default export for backward compatibility
export const theme = lightTheme;
